
<po-page-edit
  p-title="Solicitação de Compra #{{solicitacaoCompra.CC1NUM}}"
  [p-breadcrumb]="breadcrumb"
  (p-save)="confirmarSolicitacao()"
  [p-disable-submit]="bloqueiaEdicao"
>
  <form #formPrincipal="ngForm">
    <po-widget>
      <po-lookup class="po-sm-12 po-md-6 po-lg-4"
        p-label="Fornecedor"
        name="CC1FORNECELOJA"
        [(ngModel)]="fornecedorCodigoLoja"
        p-field-value="CA2CODLOJA"
        p-field-label="CA2NREDUZ"
        [p-columns]="fornecedorColumnsFilters"
        [p-field-format]="fornecedorLookupService.getFieldFormater"
        [p-filter-service]="fornecedorLookupService"
        [p-advanced-filters]="fornecedorLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Fornecedor' }"
        (p-selected)="fornecedorSelecionado($event)"
        p-show-required="true"
        p-required="false"
        [p-disabled]="bloqueiaEdicao"
      ></po-lookup>
      <po-lookup class="po-sm-12 po-md-6 po-lg-4"
        p-label="Usuário Solicitante"
        name="CC1USER"
        [(ngModel)]="solicitacaoCompra.CC1USER"
        p-field-label="CUSRNOME"
        p-field-value="CUSRID"
        [p-columns]="usuarioColumnsFilters"
        [p-field-format]="usuarioLookupService.getFieldFormater"
        [p-filter-service]="usuarioLookupService"
        [p-advanced-filters]="usuarioLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Usuário' }"
        (p-selected)="usuarioSelecionado($event)"
        p-show-required="true"
        p-required="true"
        p-disabled="true"
      ></po-lookup>
      <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
        name="DC1EMISSAO"
        p-label="Emissão"
        [(ngModel)]="solicitacaoCompra.DC1EMISSAO"
        [p-iso-format]="formatExtended"
        p-format="dd/mm/yyyy"
        p-disabled="true"
      ></po-datepicker>
    </po-widget>
    <po-table class="po-sm-12 po-md-12 po-lg-12"
      [p-striped]="true"
      [p-items]="solicitacaoCompra.items"
      [p-columns]="tabelaItensColunas"
      [p-actions]="tabelaItensActions"
      [p-sort]="false"
      p-spacing="small"
      p-height="400"
      p-container="true"
    ></po-table>
    <po-button class="po-md-12 po-mt-2" p-type="default" p-label="Adicionar Itens" (p-click)="adicionarItem()" [p-disabled]="bloqueiaEdicao"></po-button>
  </form>
</po-page-edit>


<po-modal
  #modalItem
  p-size="xl"
  p-title="Editar Item"
>
  <form #formItem="ngForm">
    <po-widget
      [p-disabled]="bloqueiaEdicao"
    >
      <po-lookup class="po-sm-12 po-md-12 po-lg-12"
        p-label="Produto"
        name="CC1PRODUTO"
        [(ngModel)]="solicitacaoCompraItem.CC1PRODUTO"
        p-field-value="CB1COD"
        p-field-label="CB1DESC"
        [p-columns]="produtoColumnsFilters"
        [p-field-format]="produtoLookupService.getFieldFormater"
        [p-filter-service]="produtoLookupService"
        [p-advanced-filters]="produtoLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Produto' }"
        [p-filter-params]="{CB1MSBLQL: '2'}"
        (p-selected)="produtoSelecionado($event)"
        p-required="true"
        p-show-required="true"
      ></po-lookup>

      <po-input class="po-sm-12 po-md-12 po-lg-12"
        name="CC1OBS"
        p-label="Observação"
        [(ngModel)]="solicitacaoCompraItem.CC1OBS"
        p-required="true"
        p-show-required="true"
        p-maxlength="100"
      ></po-input>
      <po-input class="po-sm-4 po-md-1 po-lg-1"
        name="CC1UM"
        p-label="UM"
        [(ngModel)]="solicitacaoCompraItem.CC1UM"
        p-disabled="true"
      ></po-input>
      <po-decimal class="po-sm-4 po-md-3 po-lg-3 maisti-input-number"
        name="CC1QUANT"
        p-label="Quantidade"
        [(ngModel)]="solicitacaoCompraItem.NC1QUANT"
        p-decimals-length="3"
        p-max="999999999.99"
        p-min="0.001"
        p-required="true"
        p-show-required="true"
      ></po-decimal>
      <po-datepicker class="po-sm-12 po-md-3 po-lg-3"
        name="DC1DATPRF"
        p-label="Necessidade"
        [(ngModel)]="solicitacaoCompraItem.DC1DATPRF"
        [p-iso-format]="formatExtended"
        p-format="dd/mm/yyyy"
      ></po-datepicker>
      <po-lookup class="po-sm-12 po-md-6 po-lg-5"
        p-label="Centro de Custo"
        name="CC1CC"
        [(ngModel)]="solicitacaoCompraItem.CC1CC"
        p-field-value="CCTTCUSTO"
        p-field-label="CCTTDESC01"
        [p-columns]="centroCustoColumnsFilters"
        [p-field-format]="centroCustoLookupService.getFieldFormater"
        [p-filter-service]="centroCustoLookupService"
        [p-advanced-filters]="centroCustoLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Centro de Custo' }"
        (p-selected)="ccSelecionado($event)"
        p-required="true"
        p-show-required="true"
      ></po-lookup>
      <po-lookup class="po-sm-12 po-md-6 po-lg-4"
        p-label="Conta Contábil"
        name="CC1CONTA"
        [(ngModel)]="solicitacaoCompraItem.CC1CONTA"
        p-field-value="CCT1CONTA"
        p-field-label="CCT1DESC01"
        [p-columns]="contaContabilColumnsFilters"
        [p-field-format]="contaContabilLookupService.getFieldFormater"
        [p-filter-service]="contaContabilLookupService"
        [p-advanced-filters]="contaContabilLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Conta Contábil' }"
        p-required="true"
        p-show-required="true"
      ></po-lookup>
      <po-lookup class="po-sm-12 po-md-6 po-lg-4"
        p-label="Armazém"
        name="CC1LOCAL"
        [(ngModel)]="solicitacaoCompraItem.CC1LOCAL"
        p-field-value="CNNRCODIGO"
        p-field-label="CNNRDESCRI"
        [p-columns]="armazemColumnsFilters"
        [p-field-format]="armazemLookupService.getFieldFormater"
        [p-filter-service]="armazemLookupService"
        [p-advanced-filters]="armazemLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Armazém' }"
        p-required="false"
        p-show-required="true"
        p-disabled="true"
      ></po-lookup>
    </po-widget>
  </form>
  <po-modal-footer>
    <po-button class="po-sm-12 po-md-6 po-lg-6"
      p-label="Gravar Item"
      p-icon="po-icon-ok"
      (p-click)="confirmarItem()"
    ></po-button>
    <po-button class="po-sm-12 po-md-6 po-lg-6"
      p-label="Cancelar"
      p-icon="po-icon-cancel"
      (p-click)="modalItem.close()"
      p-danger="true"
    ></po-button>
  </po-modal-footer>
</po-modal>



<po-modal
  #modalProduto
  p-size="lg"
  p-title="Produto"
>

  <form #formPrincipal="ngForm">
    <po-combo class="po-sm-12 po-md-3"
      name="CGRPNVL1"
      p-label="Grupo Nvl 1"
      [(ngModel)]="filtroProdutoLista.CGRPNVL1"
      p-icon="po-icon-search"
      p-field-label="label"
      p-field-value="value"
      p-filter-service="{{urlApiProtheus}}/wsrpdm/zc0"
      [p-filter-params]="{combobox:'S'}"
      p-disabled-init-filter="false"
      p-infinite-scroll="true"
      p-required="true"
      (p-change)="onChangeNvl1()"
      p-change-on-enter="true"
    ></po-combo>

    <po-combo class="po-sm-12 po-md-3"
      name="CGRPNVL2"
      p-label="Grupo Nvl 2"
      [(ngModel)]="filtroProdutoLista.CGRPNVL2"
      p-icon="po-icon-search"
      p-field-label="label"
      p-field-value="value"
      p-filter-service="{{urlApiProtheus}}/wsrpdm/zc1"
      [p-filter-params]="filterZC1"
      p-disabled-init-filter="false"
      p-infinite-scroll="true"
      p-required="true"
      [p-disabled]="filtroProdutoLista.CGRPNVL1 == ''"
      (p-change)="onChangeNvl2()"
      p-change-on-enter="true"
    ></po-combo>

    <po-combo class="po-sm-12 po-md-3"
      name="CB1XPDM"
      p-label="PDM"
      [(ngModel)]="filtroProdutoLista.CB1XPDM"
      p-icon="po-icon-search"
      p-field-label="label"
      p-field-value="value"
      p-filter-service="{{urlApiProtheus}}/wsrpdm/zc2"
      [p-filter-params]="filterZC2"
      p-disabled-init-filter="false"
      p-infinite-scroll="true"
      p-required="true"
      (p-change)="onChangePDM()"
      p-change-on-enter="true"
    ></po-combo>

    <po-combo class="po-sm-12 po-md-3"
      name="CB1POSIPI"
      p-label="NCM"
      [(ngModel)]="filtroProdutoLista.CB1POSIPI"
      p-icon="po-icon-search"
      p-field-label="label"
      p-field-value="value"
      p-filter-service="{{urlApiProtheus}}/wsrpdm/zc6"
      [p-filter-params]="filterPDMCombo"
      p-disabled-init-filter="false"
      p-infinite-scroll="true"
      p-required="true"
      p-clean="true"
    ></po-combo>
    <po-button class="po-md-12"
      p-label="Filtrar"
      p-icon="po-icon-search"
      (p-click)="buscarProduto(true)"
    ></po-button>
  </form>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-striped]="true"
    [p-items]="produtoItems"
    [p-columns]="produtoColunas"
    [p-sort]="true"
    p-spacing="small"
    p-height="310"
    p-container="true"
    p-selectable="true"
    p-single-select="true"
    p-hide-table-search="false"
    [p-show-more-disabled]="produtosShowMoreDisable"
    (p-show-more)="buscarProduto(false)"
    [p-filter-type]="poSearchFilterMode"
    p-infinite-scroll="true"
  ></po-table>
  <po-modal-footer>
    <po-button class="po-sm-12 po-md-6 po-lg-6"
      p-label="Confirmar seleção"
      p-icon="po-icon-ok"
      (p-click)="confirmarSelecaoProduto()"
    ></po-button>
    <po-button class="po-sm-12 po-md-6 po-lg-6"
      p-label="Cancelar"
      p-icon="po-icon-cancel"
      (p-click)="modalProduto.close()"
      p-danger="true"
    ></po-button>
  </po-modal-footer>
</po-modal>